// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalWindow_overlay__30o3v","closeModalBtn":"ModalWindow_closeModalBtn__2f0e7","modalWindow":"ModalWindow_modalWindow__30kgI"};